export type ActionConstant = 'report/fetchAsync';

export class ActionConstants {
    public static readonly fetch: string = 'report/fetchAsync';
    public static readonly updateAllReportsFilterStatus: string = 'report/updateAllReportsFilterStatus';
    public static readonly updateAllReportsPage: string = 'report/updateAllReportsPage';
    public static readonly updateAllReportsFrom: string = 'report/updateAllReportsFrom';
    public static readonly updateAllReportsTo: string = 'report/updateAllReportsTo';
    public static readonly updateAllReportOperators: string = 'report/updateAllReportOperators';
    public static readonly updateAllReportBooleanValues: string = 'report/updateAllReportBooleanValues';
    public static readonly updateAllReportLogicalOperators: string = 'report/updateAllReportLogicalOperators';
}
